import { useEffect, useState } from "react";

export function useCountdown(durationMs: number) {
  const [remainingMs, setRemainingMs] = useState(durationMs);

  useEffect(() => {
    setRemainingMs(durationMs);
    const id = setInterval(() => {
      setRemainingMs((prev) => Math.max(prev - 1000, 0));
    }, 1000);
    return () => clearInterval(id);
  }, [durationMs]);

  return Math.ceil(remainingMs / 1000);
}
